import React, { useEffect, useState } from "react";
import axios from "axios";
import { motion } from "framer-motion";
import { Quote, Star } from "lucide-react";
import { Reveal } from "./Reveal";
import { useContent } from "./content";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const CLIENTS = ["Northwind", "Meridian", "Kite Digital", "Lumen", "Arcadia", "Bluewave"];

export const Testimonials = () => {
  const c = useContent();
  const [items, setItems] = useState([]);

  useEffect(() => {
    axios.get(`${API}/testimonials`).then((r) => setItems(r.data)).catch(() => {});
  }, []);

  const featured = items.filter((t) => t.featured).slice(0, 3);
  const shown = featured.length > 0 ? featured : items.slice(0, 3);

  if (shown.length === 0) return null;

  return (
    <section data-testid="testimonials-section" className="py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-2xl mb-16">
          <Reveal>
            <span className="uppercase tracking-[0.24em] text-xs font-bold text-accent">
              {c.testimonials_eyebrow}
            </span>
            <h2 className="mt-4 font-display font-medium tracking-tight text-4xl sm:text-5xl lg:text-6xl leading-[1.02]">
              {c.testimonials_title}
            </h2>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {shown.map((t, i) => (
            <Reveal key={t.name} delay={i * 0.08}>
              <motion.div
                data-testid={`testimonial-${i}`}
                whileHover={{ y: -8 }}
                transition={{ type: "spring", stiffness: 260, damping: 22 }}
                className="h-full flex flex-col bg-card border border-border rounded-3xl p-8 hover:shadow-[0_30px_60px_-30px_rgba(18,119,110,0.3)] transition-shadow duration-500"
              >
                <div className="flex items-center justify-between">
                  <span className="grid place-items-center h-11 w-11 rounded-full bg-secondary/15 text-primary">
                    <Quote size={18} />
                  </span>
                  <div className="flex gap-0.5 text-accent">
                    {Array.from({ length: 5 }).map((_, s) => (
                      <Star key={s} size={14} fill="currentColor" />
                    ))}
                  </div>
                </div>
                <p className="mt-6 text-foreground/80 leading-relaxed flex-1">"{t.quote}"</p>
                <div className="mt-7 pt-5 border-t border-border flex items-center gap-3">
                  {t.image ? <img src={t.image} alt={t.name} className="h-11 w-11 rounded-full object-cover" data-testid={`testi-avatar-${i}`} /> : null}
                  <div>
                    <div className="font-heading font-medium text-foreground">{t.name}</div>
                    <div className="text-sm text-foreground/55">{t.role}</div>
                  </div>
                </div>
              </motion.div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.1}>
          <div className="mt-16 pt-10 border-t border-border">
            <p className="text-center text-xs uppercase tracking-[0.24em] text-foreground/40 mb-8">
              Trusted by growing teams across India
            </p>
            <div className="flex flex-wrap items-center justify-center gap-x-12 gap-y-6">
              {CLIENTS.map((c) => (
                <span
                  key={c}
                  className="font-heading text-xl md:text-2xl font-semibold text-foreground/25 hover:text-primary transition-colors duration-300"
                >
                  {c}
                </span>
              ))}
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
